/**
 * Botón contextual de ayuda «?» (AUTONOMY · Layer 2/3).
 *
 * Colocado en las cabeceras de las pantallas principales, lleva a la sección
 * de la guía in-app que documenta esa área (`AREA_HELP`). URL-direccionable:
 * `/help/<guía>?section=<sección>`.
 */
import { Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { CircleHelp } from "lucide-solid";

import { useI18n } from "@/providers/i18n-provider";
import { Link } from "@/lib/u-router";
import { helpTargetForArea } from "../registry";

export function HelpButton(props: { area: string; class?: string }) {
  const { t } = useI18n();
  const target = () => helpTargetForArea(props.area);
  return (
    <Show when={target()}>
      {(resolved) => (
        <Link
          to={`/help/${resolved().guide}`}
          search={{ section: resolved().section }}
          aria-label={t(msg`Help for this screen`)}
          title={t(msg`Help for this screen`)}
          data-testid={`help-button-${props.area}`}
          class={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent/10 hover:text-accent ${props.class ?? ""}`}
        >
          <CircleHelp class="h-5 w-5" />
        </Link>
      )}
    </Show>
  );
}
